/** Kleine React-Hooks, die mehrere Seiten brauchen. */
import { useEffect, useMemo, useState } from 'react';
import { allStatuses, badgeCount, type AppState, type Climate, type TaskStatus } from '@pflanzen/shared';
import { photoUrl } from './photos';
import { setBadge } from './push';

/** Aktuelle Uhrzeit, jede Minute neu (für „fällig heute“ usw.). */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), intervalMs);
    const onVisible = () => document.visibilityState === 'visible' && setNow(new Date());
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs]);
  return now;
}

/** Alle Aufgaben mit Fälligkeit; setzt nebenbei die Zahl am App-Symbol. */
export function useStatuses(state: AppState | null, now: Date, climate?: Climate): TaskStatus[] {
  const statuses = useMemo(() => (state ? allStatuses(state, now, climate) : []), [state, now, climate]);
  useEffect(() => {
    if (state) void setBadge(badgeCount(statuses));
  }, [state, statuses]);
  return statuses;
}

/** Foto-URL laden (null solange es lädt oder bei Fehler). */
export function usePhoto(photoId: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    setUrl(null);
    if (photoId) {
      photoUrl(photoId)
        .then((u) => alive && setUrl(u))
        .catch(() => alive && setUrl(null));
    }
    return () => {
      alive = false;
    };
  }, [photoId]);
  return url;
}
